import { render, staticRenderFns } from "./ProductImageDisplay.vue?vue&type=template&id=63a31e34&scoped=true&"
import script from "./ProductImageDisplay.vue?vue&type=script&lang=ts&"
export * from "./ProductImageDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./ProductImageDisplay.vue?vue&type=style&index=0&id=63a31e34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a31e34",
  null
  
)

export default component.exports